import { FC } from 'react';
import { IconTag } from '@tryhackme/thm-ui-components';
import { faRoute, faFlag, faNetworkWired } from '@fortawesome/pro-regular-svg-icons';
import { TypeTagProps } from '../../submissions.types';
import { StyledAnchor, StyledIconTag, StyledTagIcon } from './type-tag.styles';
export const TypeTag: FC<TypeTagProps> = ({
  type,
  userWriteupUrl
}) => <>
    {type === 'walkthrough' && <IconTag>
        <StyledTagIcon icon={faRoute} />
        Walktrough
      </IconTag>}
    {type === 'challenge' && <StyledAnchor href={(userWriteupUrl as string)} target="_blank" rel="noreferrer noopener">
        <IconTag type="info">
          <StyledTagIcon icon={faFlag} />
          Challenge
        </IconTag>
      </StyledAnchor>}
    {type === 'network' && <StyledIconTag>
        <StyledTagIcon icon={faNetworkWired} />
        Network
      </StyledIconTag>}
  </>;